
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { ClassroomModel, ListModel } from '@descomplica/dex-models';
import ProgressBar from '../progress/ProgressBar.vue';

export default Vue.extend({
  components: {
    Icon,
    ProgressBar,
  },
  props: {
    list: {
      type: Object as Vue.PropType<ListModel & { isOverdue: boolean }>,
      required: true,
    },
    isFirstIncompleteStudyPlanningList: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOverdueList(): boolean {
      return this.list.isOverdue;
    },
    hasListBeenStarted(): boolean {
      if (this.list.progress === null) return false;

      return this.list.progress > 0;
    },
  },
  methods: {
    getClassroom(id: number): ClassroomModel {
      return this.$store.getters.classroomById(id);
    },
  },
});
